import { META_PLAYLIST_CACHE, META_SCHEDULE, META_STORE, openPlayerDatabase, } from './idb/database.js';
import { idbRequest, idbTransactionDone } from './idb/request.js';
/**
 * Persists playlist cache slots + schedule snapshot in IndexedDB meta store.
 */
export class IndexedDbOfflineStateStore {
    openDb;
    dbPromise = null;
    constructor(openDb = openPlayerDatabase) {
        this.openDb = openDb;
    }
    db() {
        if (!this.dbPromise)
            this.dbPromise = this.openDb();
        return this.dbPromise;
    }
    async loadPlaylistCache() {
        const value = await this.getMeta(META_PLAYLIST_CACHE);
        return value ?? null;
    }
    async savePlaylistCache(snapshot) {
        await this.putMeta(META_PLAYLIST_CACHE, snapshot);
    }
    async loadSchedule() {
        const value = await this.getMeta(META_SCHEDULE);
        return value ?? null;
    }
    async saveSchedule(schedule) {
        if (schedule === null) {
            await this.deleteMeta(META_SCHEDULE);
            return;
        }
        await this.putMeta(META_SCHEDULE, schedule);
    }
    async clear() {
        const db = await this.db();
        const tx = db.transaction(META_STORE, 'readwrite');
        const store = tx.objectStore(META_STORE);
        store.delete(META_PLAYLIST_CACHE);
        store.delete(META_SCHEDULE);
        await idbTransactionDone(tx);
    }
    async getMeta(key) {
        const db = await this.db();
        const record = await idbRequest(db.transaction(META_STORE, 'readonly').objectStore(META_STORE).get(key));
        if (!record)
            return null;
        return record.value;
    }
    async putMeta(key, value) {
        const db = await this.db();
        const tx = db.transaction(META_STORE, 'readwrite');
        const record = { key, value };
        tx.objectStore(META_STORE).put(record);
        await idbTransactionDone(tx);
    }
    async deleteMeta(key) {
        const db = await this.db();
        const tx = db.transaction(META_STORE, 'readwrite');
        tx.objectStore(META_STORE).delete(key);
        await idbTransactionDone(tx);
    }
}
//# sourceMappingURL=indexed-db-offline-state-store.js.map